/**
 * Ryan O'Dowd
 * 2025-07-32
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      minWidth: 500,
    },
    note: {
      marginTop: globalScale * 8,
      color: colors.accent,
    },
  };
};

export default getStyles;
